import ErrorBoundary from "components/ErrorBoundary";
import React, { useState, useEffect } from "react";
import { Card, CardBody, Row, Container, Label, Col, Button, InputGroup, FormGroup, InputGroupText } from "reactstrap";
// import CEConfigurationTabs from "components/CEConfigurationTabs";
import useAxios from "hooks/useAxios";
import Calendar from 'assets/icon/calendar-icon.svg';
import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import { Field, Formik } from "formik";
import Arrow from 'assets/icon/LeftChevron.svg'
import Cancel from "src/assets/icon/cancel.svg";
import EditIcon from "assets/icon/edit.svg"
import save from "assets/icon/save.svg";
import Addicon from "assets/icon/EditConfig.svg";
import { toast } from "react-toastify";
import moment from "moment";
import { dateFormate } from "utils/columns";
import Loader from "components/Loader";


let hasDatePopupOpen = false;


const ViewConfiguration = (props) => {
  const {
    searchTerms, 
    setConfigRules,
    data,
    setRowConfig,
    setClientCongigToggle,
    refetch, loading1, setSelectedRowDynamic 
  } = props;

  const API = useAxios();


  const [loading, setLoading] = useState(false);
  const [updateClicked, setUpdateClicked] = useState(false);
  const [termDate, setTermDate] = useState();

  let data1 = data.find(i => i.contractID == searchTerms.contractID);

  const [dynamicData , setDynamicData] = useState(data1);

  useEffect(() => {
    setTermDate(dateFormate(data1.effectiveEndDate)) ,
    setDynamicData(data1) 
     setSelectedRowDynamic(data1)
  }, [refetch , data1]);

 
  const handelClickimage = () => {
    setRowConfig(true);
    setClientCongigToggle(false);
    setConfigRules(false)
    refetch()
  };




  const CancelButton = () => {
    return (
      <Button color='primary' className='reset' hidden={!updateClicked} disabled={!updateClicked} size='sm' onClick={() => {
        setUpdateClicked(false)
      }}>
        <span className="right_5">
          <img src={Cancel} alt="" />
          Cancel
        </span>{" "}
      </Button>
    )
  }

  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };

  const handleEndDate = (endDate) => {
    setTermDate(moment(new Date(endDate)).format(
      "MM/DD/YYYY"))
  };

  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };

  return (
    <div>
      {loading1 && <Loader/>}
      {/* <Container fluid className="my-3"> */}
      <Card className="border-0 shadow-top my-3">
        <CardBody className="section-devider-border">
          <ErrorBoundary>
            <Row>
              <div className="d-flex align-items-center">
                <h4
                  className="f-16 text-primary font-weight-700"
                  style={{ cursor: "pointer", marginRight: "auto" }}
                  onClick={handelClickimage}
                >
                  <span
                    style={{
                      paddingRight: "5px",
                      position: "relative",
                      top: "-1px",
                      cursor: "pointer",
                    }}
                  >
                    <img style={{ width: "9px" }} src={Arrow} />
                  </span>{" "}
                  Contract Configuration{" "}
                </h4>

              </div>


              <Col md="4">
                <p className="mt-2 f-14 mb-0">Covered Entity</p>
                <p className="mt-2 f-14 font-weight-500">
                  {searchTerms.coveredEntityName}
                </p>
              </Col>
              <Col md="4">
                <p className="mt-2 f-14 mb-0">Pharmacy Name</p>
                <p className="mt-2 f-14 font-weight-500">{searchTerms.pharmacyName}</p>
              </Col>
              <Col md="4">
                <p className="mt-2 f-14 mb-0">Covered Entity Type</p>
                <p className="mt-2 f-14 font-weight-500 ">{dynamicData.ceType}</p>
              </Col>
            </Row>
            <Col md={1}>&nbsp;</Col>
            <Row>
              <Col md="4">
                <p className="mt-2 f-14 mb-0 ">Contract Status</p>
                <p className="mt-2 f-14 font-weight-500 ">
                  {dynamicData?.contractStatus}
                </p>
              </Col>

              <Col md="4">
                <p className="mt-2 f-14 mb-0 ">Contract Live Date</p>
                <p className="mt-2 f-14 font-weight-500 ">
                  {dateFormate(data1.effectiveStartDate)}
                </p>
              </Col>

              <Col md="4">
                <p className="mt-2 f-14 mb-0">Contract Term Date</p>
                <p className="mt-2 f-14 font-weight-500 ">
               {dateFormate(data1.effectiveEndDate)} </p>
                    
              </Col>
            </Row>
          </ErrorBoundary>

       
        </CardBody>
      </Card>



    </div>
  );
};

export default ViewConfiguration;
